import util from '@bmp-vue/core/api/util'
const controller = 'Parametro'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllByPortal: async function (codigoPortal) {
    return await util.Axios.GetAll(controller + '/GetAllByPortal', { codigoPortal })
  },
})
